import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(public-routes)/(auth-pages)/auth/login/components/login-client.tsx");
